<template>
  <div>
    <el-upload
      v-loading="loading"
      ref="upload"
      :disabled="cntrldisabled"
      :action="cntrluploadapi"
      :headers="uploadHeaders"
      :list-type="listtype"
      :auto-upload="cntrlautoupload"
      multiple
      :limit="100"
      :file-list="fileList"
      :on-preview="onPreview2"
      :before-remove="beforeRemove"
      :before-upload="beforeUpload"
      :on-success="afterUpload"
      :on-remove="handleRemove"
      :accept="acceptonlyimages ? imageonly : '*'"
    >
      <i class="el-icon-plus" v-if="listtype === 'picture-card'"></i>

      <el-button
        slot="trigger"
        size="small"
        type="primary"
        v-if="listtype === 'text' && !cntrldisabled"
      >{{$t('Faylı_əlavə_et')}}</el-button>
    </el-upload>
    <div style="text-align: center; width: 100%" v-if="downloadAll && fileList.length > 0">
      <el-button size="small" type="text" @click.native="click" :loading="downloading">
        <i class="el-icon-download"></i>
        {{$t('Hamısını_yüklə')}}
      </el-button>
    </div>

    <el-dialog
      class="custom-dialog"
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :center="true"
      append-to-body
    >
      <upload-preview :selectedIndex="selectedIndex" :images="imageFileList" v-if="dialogVisible" />
    </el-dialog>

    <el-dialog
      class="custom-dialog"
      :visible.sync="dialogVideoVisible"
      :fullscreen="true"
      :center="true"
      append-to-body
      :destroy-on-close="true"
    >
      <upload-video :url="selectedVideo" v-if="dialogVideoVisible" />
    </el-dialog>
  </div>
</template>

<script>
import { GenerateHex } from "../../services/crypto";
import { api, fileurl } from "../../services/helper";
import { InsertFile, GetFiles, DeleteFile } from "../../services/files";
import { FileType } from "../../services/types";
import UploadPreview from "./UploadPreview";
import UploadVideo from "./UploadVideo";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
export default {
  name: "upload",
  computed: {
    cntrluploadapi() {
      return api + "/Upload";
    },
    imageFileList() {
      return this.fileList.filter(c => !this.video.includes(this.getFileExtension(c.urlorig)));
    }
  },
  components: {
    UploadPreview,
    UploadVideo,
  },
  props: {
    sourcetype: Number,
    sourceId: [Number, String],
    uploadapi: {
      type: String,
      default: "/",
    },
    fileurl: { type: String, default: fileurl },
    disabled: { type: Boolean, default: false },
    autoupload: { type: Boolean, default: true },
    listtype: { type: String, default: "picture-card" },
    downloadAll: { type: Boolean, default: false },
    acceptonlyimages: { type: Boolean, default: false },
  },
  data() {
    return {
          uploadingCount: 0,   // neçə fayl upload prosesindədir
    insertingCount: 0,   // neçə fayl DB insert prosesindədir
      imageonly: ".jpg,.jpeg,.png,.mp4,.mkv,.mov,.jfif",
      progress: 0,
      fileList: [],
      loading: false,
      downloading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVideoVisible: false,
      selectedIndex: 0,
      cntrlfileurl: this.fileurl,
      cntrldisabled: this.disabled,
      cntrlautoupload: this.autoupload,
      sid: this.sourceId,
      sdid: this.sourcedetId,
      filecount: 0,
      previewlist: [],
      zip: "",
      count: 0,
      fileURLs: [],
      selectedVideo: "",
      video: ["mp4", "mkv", "mov"],
      videothumb: "https://carep.hu-st.com/_assets/thumb_video.png",
      uploadHeaders: {
        Authorization: 'Bearer ' + this.$store.state.user.jwt,
      },
    };
  },
  methods: {
    getFileExtension(url) {
      if (!url) return '';
      const urlWithoutQuery = url.split('?')[0];
      const parts = urlWithoutQuery.split('.');
      if (parts.length > 1) {
        return parts.pop().toLowerCase();
      }
      return '';
    },
    submit(sourceId, sourcedetId) {
      this.sid = sourceId;
      this.sdid = sourcedetId;
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      if (!file.id) return;

      DeleteFile(file.id).then((response) => {
        this.loading = false;
        if (response.data.isSuccess) {
          this.getFiles();
        } else {
          this.$message({
            type: "error",
            message: response.data.errors[0],
          });
        }
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(this.$t('Ləğv_olunsun'), this.$t('Təsdiqləyin'), {
        confirmButtonText: this.$t('Bəli'),
        cancelButtonText: 'Xeyr',
        type: 'warning',
      });
    },

    onPreview2(file) {
      if (this.listtype === "picture-card") {
        let ext = this.getFileExtension(file.urlorig); 
        if (this.video.includes(ext)) {
          this.selectedVideo = file.urlorig;
          this.dialogVisible = false;
          this.dialogVideoVisible = true; 
        } else {
          this.selectedIndex = this.imageFileList.indexOf(file);
          this.dialogVideoVisible = false;
          this.dialogVisible = true; 
        }
      } else {
        window.open(file.url, "_blank");
      }
    },

beforeUpload(file) {
  let fname = file.name;
  let key = GenerateHex();
  let newname = key + "_" + fname;

  Object.defineProperty(file, "name", {
    writable: true,
    value: newname,
  });

  this.uploadingCount++;
},

afterUpload(uploadResp, file, fileList) {
  // uploadResp serverin /Upload endpoint response-udur
  // Sən artıq burda dbPath yoxlayırsan:
  if (!uploadResp || !uploadResp.dbPath) {
    this.uploadingCount = Math.max(0, this.uploadingCount - 1);
    return;
  }

  const f = new FileType();
  f.filename = file.raw.name;       // səndə newname artıq raw.name-da olur
  f.sourcetype = this.sourcetype;
  f.sourceId = this.sid;

  // ✅ BUNU ƏLAVƏ ET: backend InsertFile üçün dbPath/url lazımdırsa mütləq göndər
  // (Sənin backend modelinə uyğun field adını seç)
  f.dbPath = uploadResp.dbPath;
  // əgər uploadResp.url qaytarırsa:
  if (uploadResp.url) f.url = uploadResp.url;

  this.insertingCount++;
  this.loading = true;

  InsertFile(f)
    .then((res) => {
      const ok = !!(res?.data?.IsSuccess ?? res?.data?.isSuccess);
      // upload+insert sayğaclarını düzgün azaldırıq
      this.insertingCount = Math.max(0, this.insertingCount - 1);
      this.uploadingCount = Math.max(0, this.uploadingCount - 1);

      // ✅ Hamısı bitəndə 1 dəfə refresh et
      if (this.uploadingCount === 0 && this.insertingCount === 0) {
        // el-upload iç listini sıfırlayıb yenidən serverdən doldurmaq daha stabil olur
        this.$refs.upload && this.$refs.upload.clearFiles();

        this.getFiles(); // serverdən ən təzə list
      }
    })
    .catch(() => {
      this.insertingCount = Math.max(0, this.insertingCount - 1);
      this.uploadingCount = Math.max(0, this.uploadingCount - 1);
    })
    .finally(() => {
      // loading-i yalnız hamısı bitəndə söndür
      if (this.uploadingCount === 0 && this.insertingCount === 0) {
        this.loading = false;
      }
    });
},

    getFiles() {
      if (!this.cntrlfileurl) return;

      this.loading = true;
      GetFiles(this.sourcetype, this.sid).then((response) => {
        this.fillList(response.data.data);
        this.$emit("filesloaded");
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      });
    },

    click() {
      this.downloading = true;
      this.download().then(() => {
        this.downloading = false;
      });
    },
fillList(files) {
  const newList = [];
  if (!files) {
    this.fileList = [];
    return;
  }

  for (let i = 0; i < files.length; i++) {
    let fname = files[i].fileName.substring(files[i].fileName.indexOf("_") + 1);

    const ext = this.getFileExtension(files[i].url);
    const isVideo = this.video.includes(ext);
    const url = isVideo ? this.videothumb : files[i].url;

    newList.push({
      name: fname,
      year: files[i].year,
      month: files[i].month,
      id: files[i].id,
      rawname: files[i].fileName,
      url,
      urlorig: files[i].url,
    });
  }

  // ✅ yeni reference
  this.fileList = newList;

  // istəsən UI-nin tam çəkilməsini də garanti edə bilərsən
  this.$nextTick(() => {});
},

    download() {
      return new Promise((resolve, reject) => {
        let urls = [];
        this.fileURLs = [];
        this.fileList.forEach((element) => {
          urls.push(element.urlorig);
        });

        const zip = new JSZip();
        let count = 0;
        const zipFilename = "cm.zip";
        urls.forEach(async function (url) {
          const urlArr = url.split("/");
          const filename = urlArr[urlArr.length - 1];
          try {
            const file = await JSZipUtils.getBinaryContent(url);
            zip.file(filename, file, {
              binary: true,
            });
            count++;
            if (count === urls.length) {
              zip
                .generateAsync({
                  type: "blob",
                })
                .then(function (content) {
                  saveAs(content, zipFilename);
                  resolve(true);
                });
            }
          } catch (err) {
          }
        });
      });
    },
  },
  mounted() {
    this.uploadHeaders = {
      Authorization: 'Bearer ' + this.$store.state.user.jwt,
    };
    this.getFiles();
  },
  watch: {
    sourceId() {
      this.sid = this.sourceId;
      this.getFiles();
    },
    fileurl() {
      this.cntrlfileurl = this.fileurl;
      this.getFiles();
    },
    uploadapi() {
      if (!this.uploadapi) this.cntrluploadapi = "/";
      this.cntrluploadapi = this.uploadapi;
    },
    autoupload() {
      this.cntrlautoupload = this.autoupload;
    },
    disabled() {
      this.cntrldisabled = this.disabled;
    },
  },
};
</script>

<style lang="scss" scope>
.large-icon-button {
  cursor: pointer;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.large-icon-button i {
  font-size: 30px;
}

.custom-dialog .el-dialog__headerbtn {
  font-size: 2em;
  margin-top: -20px;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: red;
  font-weight: bold;
}
</style>